// The sites.js includes a JSON of all the minisite pereset which the Secondary Navigation contains.

export const sites = [
    // eCommerce
    {
        id: 'ecommerce',
        name: 'eCommerce',
        searchType: 'none',
        mainCta: true,
        mainCtaLabel: 'Create Your Store',
        mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecom_hero_email_create_your_store&postSignUp=https%3A%2F%2Fwww.wix.com%2Fnew%2Fintro&postLogin=https%3A%2F%2Fwix.com%2Fmy-account%2Fsites&originUrl=https%3A%2F%2Fwww.wix.com%2Fecommerce%2Fwebsite&loginDialogContext=signup',
        mainCtaTarget: '_self',
        mainCtaLogin: true,
        secondaryCta: false,
        removePricingFromMainMenu: true,
        removeGetStartedFromMainHeader: true,
        menuItems: [{
                label: 'Start',
                id: 'start-dropdown',
                menuItems: [
                    { label: 'eCommerce Website', link: 'https://www.wix.com/ecommerce/website', target: '_self' },
                    { label: 'Online Store', link: 'https://www.wix.com/ecommerce/online-store', target: '_self' },
                    { label: 'eCommerce Templates', link: 'https://www.wix.com/website/templates/html/online-store', target: '_blank' },
                    { label: 'Migrate', link: 'https://www.wix.com/ecommerce/start/migrate', target: '_self' }
                ]
            },
            {
                label: 'Sell',
                id: 'sell-dropdown',
                menuItems: [
                    { label: 'Sell on Wix', link: 'https://www.wix.com/ecommerce/sell', target: '_self' },
                    { label: 'Dropshipping Website', link: 'https://www.wix.com/ecommerce/dropshipping', target: '_self' },
                    { label: 'Sell Custom Merch', link: 'https://www.wix.com/ecommerce/print-on-demand', target: '_self' },
                    { label: 'Sales Channels', link: 'https://www.wix.com/ecommerce/sell/multichannel', target: '_self' },
                    { label: 'Sell Internationally', link: 'https://www.wix.com/ecommerce/sell/cross-border', target: '_self' },
                    { label: 'Point of Sale', link: 'https://www.wix.com/pos', target: '_blank' }
                ]
            },
            {
                label: 'Manage',
                id: 'manage-dropdown',
                menuItems: [
                    { label: 'Manage Your Store', link: 'https://www.wix.com/ecommerce/manage', target: '_self' },
                    { label: 'eCommerce Features', link: 'https://www.wix.com/ecommerce/features', target: '_self' },
                    { label: 'eCommerce Hosting', link: 'https://www.wix.com/ecommerce/ecommerce-hosting', target: '_self' },
                    { label: 'eCommerce Marketing', link: 'https://www.wix.com/ecommerce/marketing', target: '_self' },
                    { label: 'Buy Now, Pay Later', link: 'https://www.wix.com/ecommerce/buy-now-pay-later', target: '_self' },
                    { label: 'Accept Payments', link: 'https://www.wix.com/payments', target: '_self' }
                ]
            },
            {
                label: 'Learn',
                id: 'learn-dropdown',
                menuItems: [
                    { label: 'eCommerce Blog', link: 'https://www.wix.com/blog/explore/categories/ecommerce-101', target: '_blank' },
                    { label: 'Learn eCommerce', link: 'https://www.wix.com/learn/library/ecommerce/courses', target: '_blank' },
                    { label: 'Support', link: 'https://support.wix.com/en/wix-stores/setting-up-your-store', target: '_blank' }
                ]
            },
            { label: 'Pricing', link: 'https://www.wix.com/plans', target: '_blank' }
        ],
        languages: {
            'Español': {
                mainCtaLabel: 'Crea tu tienda',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_crea_tu_tienda&loginCompName=ecommerce_homepage_secondary_navigation_crea_tu_tienda&postSignUp=https://es.wix.com/new/intro&postLogin=https://es.wix.com/my-account/sites&overrideLocale=ES&loginDialogContext=signup',
                menuItems: [{
                        label: 'Empezar',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: 'Tienda online', link: 'https://es.wix.com/ecommerce/tienda-online', target: '_self' },
                            { label: 'Plantillas de eCommerce', link: 'https://es.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Vender',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'Vender en Wix', link: 'https://es.wix.com/ecommerce/sell', target: '_self' },
                            { label: 'Dropshipping', link: 'https://es.wix.com/ecommerce/dropshipping', target: '_self' },
                            { label: 'Impresión bajo demanda', link: 'https://es.wix.com/ecommerce/print-on-demand', target: '_self' },
                            { label: 'Canales de venta', link: 'https://es.wix.com/ecommerce/sell/multichannel', target: '_self' }
                        ]
                    },
                    {
                        label: 'Gestionar',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: 'Gestionar tienda', link: 'https://es.wix.com/ecommerce/manage', target: '_self' },
                            { label: 'Funciones', link: 'https://es.wix.com/ecommerce/features', target: '_self' },
                            { label: 'Marketing de eCommerce', link: 'https://es.wix.com/ecommerce/marketing', target: '_self' },
                            { label: 'Acepta pagos online', link: 'https://es.wix.com/payments', target: '_self' }
                        ]
                    },
                    {
                        label: 'Aprender',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: 'Blog de eCommerce', link: 'https://es.wix.com/blog/explore/categories/ecommerce-y-ventas', target: '_blank' }
                        ]
                    },
                    { label: 'Precios', link: 'https://es.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
            'Français': {
                mainCtaLabel: 'Créer la boutique',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_Créer_la_boutique&loginCompName=ecommerce_homepage_secondary_navigation_Créer_la_boutique&postSignUp=https://fr.wix.com/new/intro&postLogin=https://fr.wix.com/my-account/sites&overrideLocale=fr&loginDialogContext=signup',
                menuItems: [{
                        label: 'Commencer',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: 'Boutique en ligne', link: 'https://fr.wix.com/ecommerce/site-vente-en-ligne', target: '_self' },
                            { label: 'Templates eCommerce', link: 'https://fr.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Vendre',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'Vendre sur Wix', link: 'https://fr.wix.com/ecommerce/sell', target: '_self' },
                            { label: 'Dropshipping', link: 'https://fr.wix.com/ecommerce/dropshipping', target: '_self' },
                            { label: 'Impression à la demande', link: 'https://fr.wix.com/ecommerce/print-on-demand', target: '_self' },
                            { label: 'Canaux de vente', link: 'https://fr.wix.com/ecommerce/sell/multichannel', target: '_self' }
                        ]
                    },
                    {
                        label: 'Gérer',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: 'Gérer votre boutique', link: 'https://fr.wix.com/ecommerce/manage', target: '_self' },
                            { label: 'Fonctionnalités eCommerce', link: 'https://fr.wix.com/ecommerce/features', target: '_self' },
                            { label: 'Marketing eCommerce', link: 'https://fr.wix.com/ecommerce/marketing', target: '_self' }
                        ]
                    },
                    {
                        label: 'Découvrir',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: 'Blog e-commerce', link: 'https://fr.wix.com/blog/explore/categories/ecommerce', target: '_blank' },
                            { label: `Découvrir l'eCommerce`, link: 'https://fr.wix.com/learn/library/ecommerce/courses', target: '_blank' },
                            { label: 'Assistance', link: 'https://support.wix.com/fr/wix-stores/setting-up-your-store', target: '_blank' }
                        ]
                    },
                    { label: 'Tarifs', link: 'https://fr.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
            '日本語 (Japanese)': {
                mainCtaLabel: 'ショップを作成',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_ネットショップを作成&loginCompName=ecommerce_homepage_secondary_navigation_ネットショップを作成&postSignUp=https://ja.wix.com/new/intro&postLogin=https://ja.wix.com/my-account/sites&overrideLocale=ja&loginDialogContext=signup',
                menuItems: [{
                        label: 'サイト開設',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: 'ネットショップ作成', link: 'https://ja.wix.com/ecommerce/netshop', target: '_self' },
                            { label: 'EC サイトテンプレート', link: 'https://ja.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: '販売',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'ドロップシッピング', link: 'https://ja.wix.com/blog/2020/11/what-is-dropshipping/', target: '_blank' },
                            { label: 'オンデマンド印刷', link: 'https://ja.wix.com/blog/2020/12/how-print-on-demand-works/', target: '_blank' },
                            { label: '販売チャネル', link: 'https://ja.wix.com/blog/2022/11/what-is-multichannel-selling/', target: '_blank' },
                            { label: '越境 EC', link: 'https://ja.wix.com/blog/2021/02/how-to-start-ekkyo-ec/', target: '_blank' }
                        ]
                    },
                    {
                        label: '管理',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: 'EC 機能一覧', link: 'https://ja.wix.com/ecommerce/features', target: '_self' },
                            { label: 'マーケティングツール', link: 'https://ja.wix.com/ecommerce/marketing', target: '_self' }
                        ]
                    },
                    {
                        label: 'リソース',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: 'スモールビジネスブログ', link: 'https://ja.wix.com/blog/category/スモールビジネスのコツ/', target: '_blank' },
                            { label: 'EC ビジネスについて学ぶ', link: 'https://ja.wix.com/learn/library/ecommerce/courses', target: '_blank' },
                            { label: 'サポート', link: 'https://support.wix.com/ja/wix-%E3%82%B9%E3%83%88%E3%82%A2%E3%81%AE%E8%A8%AD%E5%AE%9A', target: '_blank' }
                        ]
                    },
                    { label: 'プラン', link: 'https://ja.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
            'Português': {
                mainCtaLabel: 'Crie sua loja',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_Crie_sua_loja&loginCompName=ecommerce_homepage_secondary_navigation_Crie_sua_loja&postSignUp=https://pt.wix.com/new/intro&postLogin=https://pt.wix.com/my-account/sites&overrideLocale=pt&loginDialogContext=signup',
                menuItems: [{
                        label: 'Começar',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: 'Loja virtual', link: 'https://pt.wix.com/ecommerce/loja-virtual', target: '_self' },
                            { label: 'Templates de loja virtual', link: 'https://pt.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Vender',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'Venda no Wix', link: 'https://pt.wix.com/ecommerce/sell', target: '_self' },
                            { label: 'Dropshipping', link: 'https://pt.wix.com/ecommerce/dropshipping', target: '_self' },
                            { label: 'Impressão sob demanda', link: 'https://pt.wix.com/ecommerce/impressao-sob-demanda', target: '_self' },
                            { label: 'Canais de venda', link: 'https://pt.wix.com/ecommerce/sell/multichannel', target: '_self' }
                        ]
                    },
                    {
                        label: 'Gerenciar',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: 'Gerenciar sua loja', link: 'https://pt.wix.com/ecommerce/manage', target: '_self' },
                            { label: 'Recursos', link: 'https://pt.wix.com/ecommerce/features', target: '_self' },
                            { label: 'Marketing para eCommerce', link: 'https://pt.wix.com/ecommerce/marketing', target: '_self' },
                            { label: 'Aceitar pagamentos', link: 'https://pt.wix.com/pagamentos', target: '_self' }
                        ]
                    },
                    {
                        label: 'Aprender',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: 'Blog de eCommerce', link: 'https://pt.wix.com/blog/category/dicas-de-ecommerce', target: '_blank' },
                            { label: 'Cursos de eCommerce', link: 'https://pt.wix.com/learn/library/ecommerce/courses', target: '_blank' },
                            { label: 'Suporte', link: 'https://support.wix.com/pt/configure-sua-loja', target: '_blank' }
                        ]
                    },
                    { label: 'Preços', link: 'https://pt.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
            'Deutsch': {
                mainCtaLabel: 'Shop erstellen',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_Shop_erstellen&loginCompName=ecommerce_homepage_secondary_navigation_Shop_erstellen&postSignUp=https://de.wix.com/new/intro&postLogin=https://de.wix.com/my-account/sites&overrideLocale=de&loginDialogContext=signup',
                menuItems: [{
                        label: 'Start',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: 'Online Shop erstellen', link: 'https://de.wix.com/ecommerce/onlineshop-erstellen', target: '_self' },
                            { label: 'Online Shop Templates', link: 'https://de.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Verkaufen',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'Verkaufen mit Wix', link: 'https://de.wix.com/ecommerce/sell', target: '_self' },
                            { label: 'Dropshipping', link: 'https://de.wix.com/blog/beitrag/was-ist-dropshipping-so-steigst-du-ins-dropshipping-geschaeft-ein', target: '_blank' },
                            { label: 'Print on Demand', link: 'https://de.wix.com/ecommerce/print-on-demand', target: '_self' },
                            { label: 'Verkaufskanäle', link: 'https://de.wix.com/ecommerce/sell/multichannel', target: '_self' }
                        ]
                    },
                    {
                        label: 'Verwalten',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: 'Deinen Shop verwalten', link: 'https://de.wix.com/ecommerce/manage', target: '_self' },
                            { label: 'eCommerce Features', link: 'https://de.wix.com/ecommerce/features', target: '_self' },
                            { label: 'eCommerce Marketing', link: 'https://de.wix.com/ecommerce/marketing', target: '_self' }
                        ]
                    },
                    {
                        label: 'Lernen',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: 'eCommerce-Blog', link: 'https://de.wix.com/blog/category/ecommerce', target: '_blank' },
                            { label: 'eCommerce lernen', link: 'https://de.wix.com/learn/library/ecommerce/courses', target: '_blank' },
                            { label: 'Support', link: 'https://support.wix.com/de/online-shop-einrichten', target: '_blank' }
                        ]
                    },
                    { label: 'Preise', link: 'https://de.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
            '한국어 (Korean)': {
                name: '온라인 쇼핑몰',
                mainCtaLabel: '쇼핑몰 제작하기',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_쇼핑몰_제작하기&loginCompName=ecommerce_homepage_secondary_navigation_쇼핑몰_제작하기&postSignUp=https://ko.wix.com/new/intro&postLogin=https://ko.wix.com/my-account/sites&overrideLocale=ko&loginDialogContext=signup',
                menuItems: [{
                        label: '시작하기',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: '온라인 쇼핑몰', link: 'https://ko.wix.com/ecommerce/website', target: '_self' },
                            { label: '쇼핑몰 템플릿', link: 'https://ko.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: '판매',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'Wix에서 판매', link: 'https://ko.wix.com/ecommerce/sell', target: '_self' },
                            { label: '드랍쉬핑', link: 'https://ko.wix.com/blog/post/what-is-dropshipping', target: '_blank' },
                            { label: '주문형 프린트', link: 'https://ko.wix.com/ecommerce/print-on-demand', target: '_self' },
                            { label: '판매 채널', link: 'https://ko.wix.com/ecommerce/sell/multichannel', target: '_self' }
                        ]
                    },
                    {
                        label: '관리',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: '비즈니스 관리', link: 'https://ko.wix.com/ecommerce/manage', target: '_self' },
                            { label: '이커머스 기능', link: 'https://ko.wix.com/ecommerce/features', target: '_self' },
                            { label: '이커머스 마케팅', link: 'https://ko.wix.com/ecommerce/marketing', target: '_self' },
                            { label: 'PG사 결제 시스템', link: 'https://ko.wix.com/payments/payment-gateways', target: '_self' }
                        ]
                    },
                    {
                        label: '가이드',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: '이커머스 블로그', link: 'https://ko.wix.com/blog/category/ecommerce', target: '_blank' },
                            { label: '도움말', link: 'https://support.wix.com/ko/setting-up-your-store-5028640', target: '_blank' }
                        ]
                    },
                    { label: '요금', link: 'https://ko.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
            'Italiano': {
                mainCtaLabel: 'Negozio online',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=ecommerce_homepage_secondary_navigation_Crea_negozio_online&loginCompName=ecommerce_homepage_secondary_navigation_Crea_negozio_online&postSignUp=https://it.wix.com/new/intro&postLogin=https://it.wix.com/my-account/sites&overrideLocale=it&loginDialogContext=signup',
                menuItems: [{
                        label: 'Inizia',
                        id: 'start-dropdown',
                        menuItems: [
                            { label: 'Negozio online', link: 'https://it.wix.com/ecommerce/negozio-online', target: '_self' },
                            { label: 'Template eCommerce', link: 'https://it.wix.com/website/templates/html/online-store', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Vendi',
                        id: 'sell-dropdown',
                        menuItems: [
                            { label: 'Vendi su Wix', link: 'https://it.wix.com/ecommerce/sell', target: '_self' },
                            { label: 'Dropshipping', link: 'https://it.wix.com/blog/dropshipping-come-far-crescere-il-tuo-business', target: '_blank' },
                            { label: 'Print on demand', link: 'https://it.wix.com/ecommerce/print-on-demand', target: '_self' },
                            { label: 'Canali di vendita', link: 'https://it.wix.com/ecommerce/sell/multichannel', target: '_self' }
                        ]
                    },
                    {
                        label: 'Gestisci',
                        id: 'manage-dropdown',
                        menuItems: [
                            { label: 'Gestisci negozio', link: 'https://it.wix.com/ecommerce/manage', target: '_self' },
                            { label: 'Funzionalità eCommerce', link: 'https://it.wix.com/ecommerce/features', target: '_self' },
                            { label: 'Marketing eCommerce', link: 'https://it.wix.com/ecommerce/marketing', target: '_self' },
                            { label: 'Accetta pagamenti', link: 'https://it.wix.com/payments', target: '_self' }
                        ]
                    },
                    {
                        label: 'Scopri',
                        id: 'learn-dropdown',
                        menuItems: [
                            { label: 'Blog eCommerce', link: 'https://it.wix.com/blog/explore/categories/ecommerce', target: '_blank' },
                            { label: 'Assistenza', link: 'https://support.wix.com/it/configurare-wix-stores', target: '_blank' }
                        ]
                    },
                    { label: 'Prezzi', link: 'https://it.wix.com/premium-purchase-plan/dynamo', target: '_blank' }
                ],
            },
        }
    },
    // Logo Maker
    {
        id: 'logoMaker',
        name: 'Logo Maker',
        searchType: 'none',
        mainCta: true,
        mainCtaLabel: 'Get My Logo',
        mainCtaLink: 'https://manage.wix.com/logo/maker/esh',
        mainCtaTarget: '_self',
        loginButton: true,
        loginButtonLabel: 'Log In',
        loginButtonLink: 'https://users.wix.com/logo/signin?color=LOGO&sendEmail=false&referralInfo=HEADER&redirectTo=http%3A%2F%2Fmanage.wix.com%2Flogo%2Fmaker%2Fesh&postSignUp=http%3A%2F%2Fmanage.wix.com%2Flogo%2Fmaker%2Fesh&originUrl=https%3A%2F%2Fwww.wix.com%2Flogo%2Fmaker&customized=logo_maker&forceRender=true&loginDialogContext=login',
        comeBackAfterSignOut: true,
        removePricingFromMainMenu: true,
        removeGetStartedFromMainHeader: true,
        menuItems: [{
                label: 'Create',
                id: 'create',
                menuItems: [
                    { label: 'Logo Maker', link: 'https://www.wix.com/logo/maker', target: '_self' },
                    { label: 'AI Logo Generator', link: 'https://www.wix.com/logo/maker/ai-logo-generator', target: '_self' },
                ]
            },
            {
                label: 'Learn',
                id: 'learn',
                menuItems: [
                    { label: 'Logo Guides', link: 'https://www.wix.com/blog/explore/categories/logo-tips', target: '_blank' },
                    { label: 'Support', link: 'https://support.wix.com/en/creating-a-logo-for-your-business', target: '_blank' },
                ]
            },
            { label: 'Hire a designer', link: 'https://www.wix.com/marketplace/hire/graphic-designer/logo-design-services', target: '_blank' }
        ]
    },
    // Domains
    {
        id: 'domains',
        name: 'Domains',
        searchType: 'none',
        mainCta: true,
        mainCtaLabel: 'Create a Site',
        mainCtaLink: 'https://users.wix.com/signin/signup/password?view=sign-up&sendEmail=true&loginCompName=SignUp_H&referralInfo=SignUp_H&postSignUp=https%3A%2F%2Fwww.wix.com%2Fnew%2Fintro%2F&postLogin=https%3A%2F%2Fmanage.wix.com%2Faccount%2Froute&loginDialogContext=signup&forceRender=true',
        mainCtaTarget: '_self',
        mainCtaLogin: true,
        loginButton: true,
        loginButtonLabel: 'Log In',
        loginButtonLink: 'https://users.wix.com/signin?view=sign-up&sendEmail=true&loginCompName=SignUp_H&referralInfo=SignUp_H&postSignUp=https%3A%2F%2Fwww.wix.com%2Fnew%2Fintro%2F&postLogin=https%3A%2F%2Fmanage.wix.com%2Faccount%2Froute&loginDialogContext=login',
        comeBackAfterSignOut: true,
        removeGetStartedFromMainHeader: true,
        menuItems: [
            { label: 'Buy Domains', id: 'buy-domains', link: 'https://www.wix.com/domains', target: '_self' },
            {
                label: 'Find Domains',
                id: 'find-domains',
                menuItems: [
                    { label: 'Domain Name Search', link: 'https://www.wix.com/domains/domain-name-search', target: '_self' },
                    { label: 'Domain Name Generator', link: 'https://www.wix.com/domains/domain-name-generator', target: '_self' },
                    { label: 'Domain Pricing', link: 'https://www.wix.com/domains/domain-pricing', target: '_self' }
                ]
            },
            {
                label: 'Extensions',
                id: 'extensions',
                menuItems: [
                    { label: '.com', link: 'https://www.wix.com/domains/tld-list/tlds/com-domain', target: '_self' },
                    { label: '.net', link: 'https://www.wix.com/domains/tld-list/tlds/net-domain', target: '_self' },
                    { label: '.org', link: 'https://www.wix.com/domains/tld-list/tlds/org-domain', target: '_self' },
                    { label: 'Full TLD List', link: 'https://www.wix.com/domains/tld-list', target: '_self' }
                ]
            },
            {
                label: 'Tools',
                id: 'tools',
                menuItems: [
                    { label: 'Business Email', link: 'https://www.wix.com/domains/business-email', target: '_self' },
                    { label: 'WHOIS Lookup', link: 'https://www.wix.com/domains/whois', target: '_self' },
                    { label: 'Transfer Your Domain', link: 'https://support.wix.com/en/transferring-domains', target: '_blank' }
                ]
            },
            {
                label: 'Learn',
                id: 'learn',
                menuItems: [
                    { label: 'Domain Guides', link: 'https://www.wix.com/blog/explore/categories/domains-guide', target: '_blank' },
                    { label: 'Domain Help Center', link: 'https://support.wix.com/en/connecting-a-domain', target: '_blank' }
                ]
            }
        ],
        languages: {
            'Español': {
                name: 'Dominios',
                mainCtaLabel: 'Crear sitio web',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://es.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=ES&loginDialogContext=forgot-password',
                loginButtonLabel: 'Entrar',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://es.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=ES&loginDialogContext=login',

                menuItems: [
                    { label: 'Comprar dominio web', id: 'buy-domains', link: 'https://es.wix.com/dominio/comprar-dominio', target: '_self' },
                    {
                        label: 'Extensiones',
                        id: 'extensions',
                        menuItems: [
                            { label: '.com', link: 'https://es.wix.com/dominio/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.net', link: 'https://es.wix.com/dominio/tld-list/tlds/net-domain', target: '_blank' },
                            { label: '.org', link: 'https://es.wix.com/dominio/tld-list/tlds/org-domain', target: '_blank' },
                            { label: 'LIsta TLD completa', link: 'https://es.wix.com/dominio/tld-list', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Herramientas',
                        id: 'tools',
                        menuItems: [
                            { label: 'Correo empresarial', link: 'https://es.wix.com/dominio/correro-empresarial', target: '_blank' },
                            { label: 'Transfiere tu dominio a Wix', link: 'https://support.wix.com/es/transferir-dominios', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Recursos',
                        id: 'learn',
                        menuItems: [
                            { label: 'Qué es un dominio web', link: 'https://es.wix.com/blog/que-es-un-dominio', target: '_blank' },
                            { label: 'Centro de Ayuda', link: 'https://support.wix.com/es/conectar-un-dominio', target: '_blank' }
                        ]
                    }
                ]
            },
            'Français': {
                name: 'Nom de domaine',
                mainCtaLabel: 'Créer un site',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://fr.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=FR&loginDialogContext=forgot-password',
                loginButtonLabel: 'Se connecter',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://fr.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=FR&loginDialogContext=login',

                menuItems: [
                    { label: 'Acheter un nom de domaine', id: 'buy-domains', link: 'https://fr.wix.com/nom-de-domaine', target: '_self' },
                    {
                        label: 'Extensions',
                        id: 'extensions',
                        menuItems: [
                            { label: '.com', link: 'https://fr.wix.com/nom-de-domaine/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.net', link: 'https://fr.wix.com/nom-de-domaine/tld-list/tlds/net-domain', target: '_blank' },
                            { label: '.org', link: 'https://fr.wix.com/nom-de-domaine/tld-list/tlds/org-domain', target: '_blank' },
                            { label: 'Voir la liste complète', link: 'https://fr.wix.com/nom-de-domaine/tld-list', target: '_blank' },
                        ]
                    },
                    {
                        label: 'Outils',
                        id: 'tools',
                        menuItems: [
                            { label: 'E-mail professionnel', link: 'https://fr.wix.com/nom-de-domaine/email-professionnel', target: '_blank' },
                            { label: 'Transférer des domaines vers Wix', link: 'https://support.wix.com/fr/transf%C3%A9rer-des-domaines-vers-wix', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Infos',
                        id: 'learn',
                        menuItems: [
                            { label: `Qu'est-ce qu'un nom de domaine`, link: 'https://fr.wix.com/blog/guide-nom-de-domaine', target: '_blank' },
                            { label: `Centre d'assistance`, link: 'https://support.wix.com/fr/connecter-un-domaine', target: '_blank' }
                        ]
                    }
                ]
            },
            '日本語 (Japanese)': {
                name: 'ドメイン',
                mainCtaLabel: 'サイトを作成',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://ja.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=JA&loginDialogContext=forgot-password',
                loginButtonLabel: 'ログイン',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://ja.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=JA&loginDialogContext=login',
                menuItems: [
                    { label: 'ドメイン取得', id: 'buy-domains', link: 'https://ja.wix.com/domain/names', target: '_self' },
                    { label: '空きドメイン検索', id: 'find-domains', link: 'https://ja.wix.com/domain/name-search', target: '_self' },
                    {
                        label: 'TLD',
                        id: 'extensions',
                        menuItems: [
                            { label: '.com', link: 'https://ja.wix.com/domain/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.net', link: 'https://ja.wix.com/domain/tld-list/tlds/net-domain', target: '_blank' },
                            { label: '.org ', link: 'https://ja.wix.com/domain/tld-list/tlds/org-domain', target: '_blank' },
                            { label: 'TLD 一覧', link: 'https://ja.wix.com/domain/tld-list', target: '_blank' }
                        ]
                    },
                    {
                        label: 'ツール',
                        id: 'tools',
                        menuItems: [
                            { label: '独自ドメインメール', link: 'https://ja.wix.com/domain/business-email', target: '_blank' },
                            { label: 'ドメイン移管', link: 'https://support.wix.com/ja/%E3%83%89%E3%83%A1%E3%82%A4%E3%83%B3%E3%81%AE%E7%A7%BB%E7%AE%A1', target: '_blank' }
                        ]
                    },
                    {
                        label: 'リソース',
                        id: 'learn',
                        menuItems: [
                            { label: 'ドメイン取得方法', link: 'https://ja.wix.com/blog/2020/12/how-to-register-a-domain-name/', target: '_blank' },
                            { label: 'ドメインヘルプセンター', link: 'https://support.wix.com/ja/%E3%83%89%E3%83%A1%E3%82%A4%E3%83%B3%E3%81%AE%E6%8E%A5%E7%B6%9A', target: '_blank' }
                        ]
                    }
                ]
            },
            'Português': {
                name: 'Domínios',
                mainCtaLabel: 'Crie um site',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://pt.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=PT&loginDialogContext=forgot-password',
                loginButtonLabel: 'Entrar',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https%3A%2F%2Fpt.wix.com%2Fnew%2Fintro&postLogin=https%3A%2F%2Fmanage.wix.com%2Faccount&overrideLocale=PT&loginDialogContext=login&originUrl=&forceRender=true',

                menuItems: [
                    { label: 'Comprar domínio', id: 'buy-domains', link: 'https://pt.wix.com/dominio/comprar-dominio', target: '_self' },
                    {
                        label: 'Extensões de domínio',
                        id: 'extensions',
                        menuItems: [
                            { label: '.com', link: 'https://pt.wix.com/dominio/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.net', link: 'https://pt.wix.com/dominio/tld-list/tlds/net-domain', target: '_blank' },
                            { label: '.org', link: 'https://pt.wix.com/dominio/tld-list/tlds/org-domain', target: '_blank' },
                            { label: 'Ver lista completa', link: 'https://pt.wix.com/dominio/tld-list', target: '_blank' }
                        ]
                    },

                    
                    {
                        label: 'Recursos',
                        id: 'tools',
                        menuItems: [
                            { label: 'Email profissional', link: 'https://pt.wix.com/dominio/email-profissional', target: '_blank' },
                            { label: 'Transfira seu domínio ao Wix', link: 'https://support.wix.com/pt/transfer%C3%AAncia-de-dom%C3%ADnios', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Saiba mais',
                        id: 'learn',
                        menuItems: [
                            { label: `O que é um domínio?`, link: 'https://pt.wix.com/blog/guia-nome-de-dominio', target: '_blank' },
                            { label: `Como registrar um domínio?`, link: 'https://pt.wix.com/blog/como-registrar-dominio-guia', target: '_blank' },
                            { label: `Central de Ajuda`, link: 'https://support.wix.com/pt/conecte-um-dom%C3%ADnio', target: '_blank' }
                        ]
                    }
                ]
            },
            'Deutsch': {
                name: 'Domains',
                mainCtaLabel: 'Website erstellen',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://de.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=DE&loginDialogContext=forgot-password',
                loginButtonLabel: 'Einloggen',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://de.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=DE&loginDialogContext=login',

                menuItems: [
                    { label: 'Domain kaufen', id: 'buy-domains', link: 'https://de.wix.com/domain/kaufen', target: '_self' },
                    { label: 'Domain finden', id: 'find-domains', link: 'https://de.wix.com/domain/check', target: '_self' },
                         {
                        label: 'TLD-Endungen',
                        id: 'extensions',
                        menuItems: [
                            { label: '.com', link: 'https://de.wix.com/domain/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.net', link: 'https://de.wix.com/domain/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.org', link: 'https://de.wix.com/domain/tld-list/tlds/com-domain', target: '_blank' },
                            { label: 'Vollständige TLD-Liste', link: 'https://de.wix.com/domain/tld-list', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Tools',
                        id: 'tools',
                        menuItems: [
                            { label: 'Eigene E-Mail-Adresse', link: 'https://de.wix.com/domain/eigene-email-domain', target: '_blank' },
                            { label: 'Domain transferieren', link: 'https://support.wix.com/de/domains-zu-wix-transferieren', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Infos',
                        id: 'learn',
                        menuItems: [
                            { label: `Was ist eine Domain?`, link: 'https://de.wix.com/blog/beitrag/was-ist-eine-domain', target: '_blank' },
                            { label: `Was kostet eine Domain?`, link: 'https://de.wix.com/blog/beitrag/was-kostet-eine-domain-und-warum-solltest-du-eine-domain-kaufen', target: '_blank' },
                            { label: `Hilfe-Center`, link: 'https://support.wix.com/de/domains', target: '_blank' }
                        ]
                    }
                ]
            },
            'Italiano': {
                name: 'Dominio',
                mainCtaLabel: 'Crea un sito',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://it.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=IT&loginDialogContext=forgot-password',
                loginButtonLabel: 'Accedi',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://it.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=IT&loginDialogContext=login',

                menuItems: [
                    { label: 'Acquista dominio', id: 'buy-domains', link: 'https://it.wix.com/domain/names', target: '_self' },
                    {
                        label: 'Estensioni',
                        id: 'extensions',
                        menuItems: [
                            { label: '.com', link: 'https://it.wix.com/domain/tld-list/tlds/com-domain', target: '_blank' },
                            { label: '.net', link: 'https://it.wix.com/domain/tld-list/tlds/net-domain', target: '_blank' },
                            { label: '.org', link: 'https://it.wix.com/domain/tld-list/tlds/org-domain', target: '_blank' },
                            { label: 'Vedi la lista completa', link: 'https://it.wix.com/domain/tld-list', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Strumenti',
                        id: 'tools',
                        menuItems: [
                            { label: 'Email professionale', link: 'https://it.wix.com/domain/business-email', target: '_blank' },
                            { label: 'Trasferisci il tuo dominio', link: 'https://support.wix.com/it/trasferire-domini-a-wix', target: '_blank' }
                        ]
                    },
                    {
                        label: 'Risorse',
                        id: 'learn',
                        menuItems: [
                            { label: `Cos'è un nome di dominio`, link: 'https://it.wix.com/blog/cosa-e-un-nome-di-dominio', target: '_blank' },
                            { label: `Come registrare un dominio`, link: 'https://it.wix.com/blog/come-registrare-un-dominio', target: '_blank' },
                            { label: `Centro di Assistenza dominio`, link: 'https://support.wix.com/it/collegare-un-dominio', target: '_blank' }
                        ]
                    }
                ]
            },
            '한국어 (Korean)': {
                name: '도메인',
                mainCtaLabel: '사이트 만들기',
                mainCtaLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://ko.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=KO&loginDialogContext=forgot-password',
                loginButtonLabel: '로그인',
                loginButtonLink: 'https://users.wix.com/signin?referralInfo=domain_local_navigation_login_cta&loginCompName=domain_local_navigation_login_cta&postSignUp=https://ko.wix.com/new/intro&postLogin=https://manage.wix.com/account&overrideLocale=ko&loginDialogContext=login',

                menuItems: [
                    { label: '도메인 구매', id: 'buy-domains', link: 'https://ko.wix.com/domain/names', target: '_self' },
                    { label: '최상위 도메인 전체 목록', id: 'extensions', link: 'https://ko.wix.com/domain/tld-list', target: '_self' },
                    {
                        label: '도구',
                        id: 'tools',
                        menuItems: [
                            { label: '비즈니스 이메일', link: 'https://ko.wix.com/domain/business-email', target: '_blank' },
                            { label: '기존 도메인 이전', link: 'https://support.wix.com/ko/%EB%8F%84%EB%A9%94%EC%9D%B8-%EC%9D%B4%EC%A0%84%ED%95%98%EA%B8%B0', target: '_blank' }
                        ]
                    },
                    {
                        label: '알아보기',
                        id: 'learn',
                        menuItems: [
                            { label: `도메인 가이드`, link: 'https://ko.wix.com/blog/post/how-to-register-a-domain-name', target: '_blank' },
                            { label: `도메인 도움말 센터`, link: 'https://support.wix.com/ko/%EB%8F%84%EB%A9%94%EC%9D%B8-%EC%97%B0%EA%B2%B0', target: '_blank' }
                        ]
                    }
                ]
            }
        }
    },
    // Wix Blog
    {
        id: 'wixBlog',
        name: 'Wix Blog',
        nameLink: 'https://www.wix.com/blog',
        searchType: 'wixSearch',
        mainCta: true,
        mainCtaLabel: 'Create your website',
        mainCtaLink: 'https://users.wix.com/signin?utm_campaign=bd_blog_mobile&experiment_id=main_all_signup&_gl=1*ng59dh*_ga*MTA0MTE5OTAwOS4xNjE0NTQxMjEx*_ga_H314XQHSPY*MTYxNDY3NjgyNi4xLjAuMTYxNDY3NjgyNi4w&loginDialogContext=signup&forceRender=true&postSignUp=https%3A%2F%2Fwww.wix.com%2Fnew%2Fintro&postLogin=https%3A%2F%2Fwix.com%2Fmy-account%2Fsites',
        mainCtaTarget: '_self',
        mainCtaLogin: true,
        secondaryCta: false,
        loginButton: false,
        comeBackAfterSignOut: true,
        removeGetStartedFromMainHeader: true,
        menuItems: [{
            label: 'Build Your Website',
            id: 'buildYourWebsite',
            menuItems: [
                { label: 'Website Building', link: 'https://www.wix.com/blog/explore/categories/website-essentials', target: '_self' },
                { label: 'Domain Names & Setup Guides', link: 'https://www.wix.com/blog/explore/categories/domains-guide', target: '_self' },
                { label: 'Website Inspiration', link: 'https://www.wix.com/blog/explore/categories/website-inspiration', target: '_self' },
                { label: 'Portfolio Websites', link: 'https://www.wix.com/blog/explore/categories/portfolio-websites', target: '_self' },
                { label: 'Blog Like a Pro', link: 'https://www.wix.com/blog/explore/categories/blog-like-a-pro', target: '_self' },
                { label: 'Wix Expert Guides', link: 'https://www.wix.com/blog/explore/categories/ultimate-guides', target: '_self' }
            ]
        }, {
            label: 'Grow Your Business',
            id: 'growYourBusiness',
            menuItems: [
                { label: 'Ecommerce 101', link: 'https://www.wix.com/blog/explore/categories/ecommerce-101', target: '_self' },
                { label: 'Business Strategies', link: 'https://www.wix.com/blog/explore/categories/business-strategies', target: '_self' },
                { label: 'Business Ideas', link: 'https://www.wix.com/blog/explore/categories/business-ideas', target: '_self' },
                { label: 'Marketing Made Simple', link: 'https://www.wix.com/blog/explore/categories/marketing-insights', target: '_self' },
                { label: 'AI Knowledge Hub', link: 'https://www.wix.com/blog/explore/categories/ai-knowledge-hub', target: '_self' }
            ]
        }],
        languages: {
            'Italiano': {
                name: 'Wix Blog',
                nameLink: 'https://it.wix.com/blog',
                searchType: 'wixSearch',
                mainCta: true,
                mainCtaLabel: 'Crea il tuo sito',
                mainCtaLink: 'https://users.wix.com/signin?utm_campaign=bd_blog&experiment_id=it_all_cta&loginDialogContext=signup&overrideLocale=it&forceRender=true',
                mainCtaTarget: '_self',
                mainCtaLogin: true,
                secondaryCta: true,
                secondaryCtaLabel: 'Iscriviti',
                secondaryCtaLink: 'https://it.wix.com/blog/iscrizione',
                secondaryCtaTarget: '_self',
                loginButton: false,
                comeBackAfterSignOut: true,
                removeGetStartedFromMainHeader: true,
                menuItems: [{
                        label: 'Categorie',
                        id: 'categorie',
                        menuItems: [
                            { label: 'Creazione siti web', link: 'https://it.wix.com/blog/explore/categories/creazione-siti-web', target: '_self' },
                            { label: 'Consigli per il tuo business', link: 'https://it.wix.com/blog/explore/categories/consigli-per-il-tuo-business', target: '_self' },
                            { label: 'Strategie di marketing', link: 'https://it.wix.com/blog/explore/categories/strategie-di-marketing', target: '_self' },
                            { label: 'eCommerce', link: 'https://it.wix.com/blog/explore/categories/ecommerce', target: '_self' },
                        ]
                    },
                    {
                        label: 'Guide',
                        id: 'guide',
                        menuItems: [
                            { label: 'Come creare un sito web', link: 'https://it.wix.com/blog/come-fare-un-sito-web', target: '_self' },
                            { label: 'Come avviare un business online', link: 'https://it.wix.com/blog/avviare-un-business-online', target: '_self' },
                            { label: 'Guida al web design', link: 'https://it.wix.com/blog/cosa-e-il-web-design-una-guida-per-principianti', target: '_self' },
                            { label: 'Come aprire un negozio online', link: 'https://it.wix.com/blog/come-aprire-un-ecommerce-online', target: '_self' },
                            { label: 'Lista dei tipi di marketing', link: 'https://it.wix.com/blog/tipi-di-marketing', target: '_self' }
                        ]
                    }
                ],
            }
        }
    },

    // Channels
    {
        id: 'wixChannels',
        name: 'Channels',
        nameLink: 'https://www.wix.com/channels',
        searchType: 'none',
        mainCta: true,
        mainCtaLabel: `Let's Talk`,
        mainCtaLink: 'https://www.wix.com/channels/form?utm_source=channels_lp&utm_campaign=main&utm_medium=cta-header',
        mainCtaTarget: '_blank',
        loginButton: false,
        comeBackAfterSignOut: true,
        removeGetStartedFromMainHeader: true,
        menuItems: [
            { label: 'Resources', link: 'https://www.wix.com/blog/explore/categories/b2b-expertise', target: '_blank' }
        ]
    }
]

// { label: '', link: '', target: '_self'  }